import { useState } from "react";
import google from "../../assets/images/buttons/google.svg";
import googleOnHover from "../../assets/images/buttons/googleOnHover.svg";
import apple from "../../assets/images/buttons/apple.svg";
import appleOnHover from "../../assets/images/buttons/appleOnHover.svg";

const useMainSection = () => {
  const width = typeof window !== "undefined" ? window.innerWidth : null;

  const [buttonGoogle, setButtonGoogle] = useState(google);
  const [buttonApple, setButtonApple] = useState(apple);

  const googleHovered = () => {
    setButtonGoogle(googleOnHover);
  };

  const googleUnhovered = () => {
    setButtonGoogle(google);
  };

  const appleHovered = () => {
    setButtonApple(appleOnHover);
  };

  const appleUnhovered = () => {
    setButtonApple(apple);
  };

  return {
    buttonGoogle,
    buttonApple,
    googleHovered,
    googleUnhovered,
    appleHovered,
    appleUnhovered,
    width,
  };
};

export default useMainSection;
